module.exports = __webpack_public_path__ + "img/why-claim.5c3e68c9.svg";